export default "__VITE_PUBLIC_ASSET__95e70e27__"